import { styled, Button } from "@mui/material";
import theme from "src/styles/theme";

export const StyledButton = styled(Button)(() => ({
  background: theme.palette.secondary.gradient,
  color: "white",
  fontSize: "18px",
  fontWeight: "bold",
  borderRadius: "4px",
  boxShadow: "4px 4px 12px 0px rgba(255, 255, 255, 0.2)",
  textTransform: "none",
  padding: "16px",
  width: "100%",
  "&:hover": {
    opacity: 0.9,
    background: theme.palette.secondary.gradient,
  },
}));
